import { createFileRoute, Outlet, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { projectsApi } from "@/api/projects";

export const Route = createFileRoute("/app/projects/$pid")({
  component: ProjectLayout,
});

function ProjectLayout() {
  const { pid } = Route.useParams();
  const { data: project, isLoading } = useQuery({
    queryKey: ["project", pid],
    queryFn: () => projectsApi.get(pid),
  });

  return (
    <div className="space-y-8">
      <div>
        <Link to="/app" className="text-sm text-ink/55 hover:text-ink">← All projects</Link>
        <h1 className="mt-2 text-2xl font-semibold">
          {isLoading ? "…" : project?.name ?? "Project"}
        </h1>
        {project?.suspended && (
          <span className="mt-2 inline-block rounded bg-red-500/15 px-2 py-0.5 text-xs font-medium text-red-600">
            Suspended
          </span>
        )}
        <nav className="mt-4 flex gap-4 border-b border-ink/8 text-sm">
          <Tab to="/app/projects/$pid"           pid={pid}>Overview</Tab>
          <Tab to="/app/projects/$pid/keys"      pid={pid}>API keys</Tab>
          <Tab to="/app/projects/$pid/members"   pid={pid}>Members</Tab>
          <Tab to="/app/projects/$pid/usage"     pid={pid}>Usage</Tab>
          <Tab to="/app/projects/$pid/plan"      pid={pid}>Plan</Tab>
          <Tab to="/app/projects/$pid/payments"  pid={pid}>Payments</Tab>
          <Tab to="/app/projects/$pid/settings"  pid={pid}>Settings</Tab>
        </nav>
      </div>
      <Outlet />
    </div>
  );
}

function Tab({ to, pid, children }: { to: string; pid: string; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      params={{ pid }}
      activeOptions={{ exact: true }}
      className="border-b-2 border-transparent pb-2 text-ink/55 hover:text-ink [&.active]:border-primary-600 [&.active]:text-primary-700"
    >
      {children}
    </Link>
  );
}
